import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Vitals from './vitals';
import VitalsDetail from './vitals-detail';
import VitalsUpdate from './vitals-update';
import VitalsDeleteDialog from './vitals-delete-dialog';

const VitalsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Vitals />} />
    <Route path="new" element={<VitalsUpdate />} />
    <Route path=":id">
      <Route index element={<VitalsDetail />} />
      <Route path="edit" element={<VitalsUpdate />} />
      <Route path="delete" element={<VitalsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default VitalsRoutes;
